import { createAction } from 'redux-starter-kit';
import api from 'api';
export const SET_CIP_CATEGORIES = 'set-cip-categories';
export const SET_MPS_FIRMS = 'set-mps-firms';

const setCipCategories = createAction(SET_CIP_CATEGORIES);
const setMpsFirms = createAction(SET_MPS_FIRMS);

export const cipActions = {
  setCipCategories,
  setMpsFirms,
  getCipCategories: () => (dispatch: any) => {
    return api.getCipCatgories().then(({ data }) => {
      dispatch(setCipCategories(data));
      return data;
    });
  },
  getMpsFirms: () => (dispatch: any) => {
    return api.getMpsFirms().then(({ data }) => {
      dispatch(setMpsFirms(data));
      return data;
    });
  }
};
